import { Confirm } from '@wix/wix-ui-icons-common'
import cs from 'classnames'
import React, { FC } from 'react'

import s from './WixMobileCheckToggle.scss'
import { wixMobileCheckToggleDataHooks } from './WixMobileCheckToggleDataHooks'

interface WixMobileCheckToggleProps {
  isChecked: boolean
  dataHook?: string
}
export const WixMobileCheckToggle: FC<WixMobileCheckToggleProps> = ({ isChecked, dataHook }) => {
  return (
    <div
      className={cs(s.toggle, {
        [s.checked]: isChecked,
      })}
      data-hook={dataHook}
    >
      {isChecked && <Confirm size="24px" className={s.icon} data-hook={wixMobileCheckToggleDataHooks.icon()} />}
    </div>
  )
}
